var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#4C6FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 16C22.4477 16 22 15.5523 22 15C22 14.4477 22.4477 14 23 14H28C28.5523 14 29 14.4477 29 15V20C29 20.5523 28.5523 21 28 21C27.4477 21 27 20.5523 27 20V17.4142L21.7071 22.7071C21.3166 23.0976 20.6834 23.0976 20.2929 22.7071L18 20.4142L12.7071 25.7071C12.3166 26.0976 11.6834 26.0976 11.2929 25.7071C10.9024 25.3166 10.9024 24.6834 11.2929 24.2929L17.2929 18.2929C17.6834 17.9024 18.3166 17.9024 18.7071 18.2929L21 20.5858L25.5858 16H23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpGraph);
export default __webpack_public_path__ + "static/media/up_graph.51b4191a7781fd3a6d59bae17fdc8481.svg";
export { ForwardRef as ReactComponent };